"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRuntimeSessionId = getRuntimeSessionId;
exports.setRuntimeSessionId = setRuntimeSessionId;
const shared_1 = require("../shared");
let sessionId;
function getRuntimeSessionId() {
    if (sessionId)
        return sessionId;
    const storageKey = (0, shared_1.buildCookieName)();
    sessionId = sessionStorage.getItem(storageKey) || undefined;
    return sessionId;
}
function setRuntimeSessionId(id) {
    sessionId = id;
    const storageKey = (0, shared_1.buildCookieName)();
    sessionStorage.setItem(storageKey, id);
}
